import PerformanceTrendsChart from './PerformanceTrendsChart.vue';

const AnalystConsensus = {
  el: '#v-analyst-consensus',
  components: {
    PerformanceTrendsChart: PerformanceTrendsChart
  }
};
export default AnalystConsensus;
